import { getSchedules } from "@/services/schedules";

export default {
  state: {
    calendarViewType: "month",
    calendarDate: null,
    calendarInfos: {},
    updateData: false,

    scheduleData: [],
    holidays: [],

    searchSchedule: {
      type: null,
      unity: null,
      status: null,
      availability: null,
      professional: null,
      procedure: null,
      group: null,
      occupation: null,
      subOccupation: null,
      diagnostic: null,
    },

    unityDataInSchedule: {},

    schedule: {
      id: null,
      date: null,
      initialHour: null,
      endHour: null,
      procedure: null,
      group: [],
      occupation: null,
      subOccupation: null,
      diagnostic: [],
      professionals: [],
      availability: null,
      availableVacancies: null,
      status: null,
    },

    updateSchedule: false,
    visibility: false,
    types: [],
  },

  getters: {
    getCalendarViewType: (state) => state.calendarViewType,
    getCalendarDate: (state) => state.calendarDate,
    getCalendarInfos: (state) => state.calendarInfos,
    getScheduleUpdateData: (state) => state.updateData,
    getScheduleData: (state) => state.scheduleData,
    getHolidays: (state) => state.holidays,
    getSearchSchedule: (state) => state.searchSchedule,
    getCreateUpdateSchedule: (state) => state.schedule,
    getScheduleStatus: (state) => state.updateSchedule,
    getVisibility: (state) => state.visibility,
    getScheduleTypes: (state) => state.types,
  },

  mutations: {
    setCalendarViewType(state, type) {
      state.calendarViewType = type;
    },

    setCalendarDate(state, date) {
      state.calendarDate = date;
    },

    setCalendarInfos(state, infos) {
      state.calendarInfos = infos;
    },

    setScheduleUpdateData(state) {
      state.updateData = !state.updateData;
    },

    async setScheduleData(state, filters) {
      const requestResponse = await getSchedules(filters);

      if (requestResponse.status) {
        state.scheduleData = requestResponse.response;
      }
    },

    setHolidays(state, dates) {
      state.holidays = dates;
    },

    setSearchSchedule(state) {
      state.searchSchedule = {
        type: null,
        unity: null,
        status: null,
        availability: null,
        professional: null,
        procedure: null,
        group: null,
        occupation: null,
        subOccupation: null,
        diagnostic: null,
      };
    },

    setUnityDataForSchedule(state, unity) {
      state.unityDataInSchedule = unity;
    },

    setCreateUpdateSchedule(state, data) {
      const isUpdate = Object.keys(data).length > 0;

      state.schedule = {
        id: isUpdate ? data.id : null,

        unity: isUpdate ? data.unity_id : null,
        county: isUpdate ? data.county : null,
        macroregion: isUpdate ? data.macroregion : null,
        healthRegion: isUpdate ? data.health_region : null,

        type: isUpdate ? data.type_schedule_id : null,
        date: isUpdate ? data.schedule_data : null,
        initialHour: isUpdate ? data.start_time : null,
        endHour: isUpdate ? data.end_time : null,
        procedureVersion: isUpdate ? data.procedure_version : null,

        procedureName: isUpdate ? data.name_procedure : null,
        procedure: isUpdate
          ? data.type_schedule_id === "1"
            ? parseInt(data.co_procedure)
            : data.co_procedure
          : state.searchSchedule.procedure,

        groupName: isUpdate
          ? data.type_schedule_id === "1"
            ? data.procedure_type.name
            : null
          : null,
        group: isUpdate
          ? data.type_schedule_id === "1"
            ? data.procedure_type.id
            : null
          : null,

        occupation: isUpdate
          ? data.co_occupation
          : state.searchSchedule.occupation,
        occupationName: isUpdate ? data.name_occupation : null,
        subOccupation: isUpdate
          ? data.co_sub_occupation
          : state.searchSchedule.subOccupation,
        subOccupationName: isUpdate ? data.name_sub_occupation : null,
        diagnostic: isUpdate
          ? data.diagnoses
          : [state.searchSchedule.diagnostic],
        diagnosticName: isUpdate ? data.name_diagnosis : [],

        professionals: isUpdate
          ? data.professionals.map((item) => item.id)
          : [],
        availability: isUpdate ? data.availability_schedule.id : null,
        availableVacancies: isUpdate ? data.vacancies : null,
        status: isUpdate ? data.status_schedule.id : 1,

        // PPP
        proceduresPPPData: state.unityDataInSchedule.groupProcedures,

        // AMBULATORIAL INICIAL
        proceduresData: state.unityDataInSchedule.unityOcupationProcedures,
        occupations: state.unityDataInSchedule.unityOcupationProcedures,
        subOccupations: state.unityDataInSchedule.unityOcupationProcedures,

        // AMBULATORIAL EGRESSO
        egressProceduresData:
          state.unityDataInSchedule.unityOcupationProceduresEgress,
        egressOccupations:
          state.unityDataInSchedule.unityOcupationProceduresEgress,
        egressSubOccupations:
          state.unityDataInSchedule.unityOcupationProceduresEgress,

        // AMBULATORIAL ONCOLOGIA
        oncologyProceduresData:
          state.unityDataInSchedule.unityOcupationProcedureUnaconOncologys,
        oncologyOccupations:
          state.unityDataInSchedule.unityOcupationProcedureUnaconOncologys,
        oncologySubOccupations:
          state.unityDataInSchedule.unityOcupationProcedureUnaconOncologys,

        // Consulta Pré-cirurgica
        electiveProceduresData:
          state.unityDataInSchedule.unityOcupationProcedureEletives,
        electivOccupations:
          state.unityDataInSchedule.unityOcupationProcedureEletives,
        electivSubOccupations:
          state.unityDataInSchedule.unityOcupationProcedureEletives,

        professionalsData: state.unityDataInSchedule.professionals,
      };

      state.updateSchedule = isUpdate;
    },

    setVisibility(state, status) {
      state.visibility = status;
    },

    setScheduleTypes(state, types) {
      state.types = types;
    },
  },

  actions: {
    changeCalendarViewType(context, type) {
      context.commit("setCalendarViewType", type);
    },

    changeCalendarDate(context, date) {
      context.commit("setCalendarDate", date);
    },

    changeCalendarInfos(context, infos) {
      context.commit("setCalendarInfos", infos);
    },

    changeScheduleUpdateData(context) {
      context.commit("setScheduleUpdateData");
    },

    changeScheduleData(context, filters) {
      context.commit("setScheduleData", filters);
    },

    changeHolidays(context, dates) {
      context.commit("setHolidays", dates);
    },

    changeSearchSchedule(context) {
      context.commit("setSearchSchedule");
    },

    changeUnityDataForSchedule(context, unity) {
      context.commit("setUnityDataForSchedule", unity);
    },

    changeCreateUpdateSchedule(context, data) {
      context.commit("setCreateUpdateSchedule", data);
    },

    changeVisibility(context, status) {
      context.commit("setVisibility", status);
    },

    changeScheduleTypes(context, types) {
      context.commit("setScheduleTypes", types);
    },
  },
};
